import { z } from "zod";
/**
 * Processa etapas com SLA vencido (escalonamento). Uso interno/cron; `now`
 * opcional permite determinismo em teste (FASE-06-T48).
 */
export const tickWorkflowSchema = z.object({
    now: z.string().datetime().optional(),
});
//# sourceMappingURL=tick-workflow.js.map